$('.flexslider-wrapper').flexslider({
    selector: ".flexslider > li",
    animation: "slide",
    controlNav: true,
    slideShow: true,
    smoothHeight: true,
    start: function(){
        $('.flexslider-item').css({
            'position': 'relative',
            'opacity': 1
        });
    }
});